<template>
  <ValidationProvider
    ref="prov"
    :mode="validationModeComputed"
    v-slot="{ errors }"
    :rules="rulesComputed"
    :name="labelComputed"
  >
    <v-text-field
      v-model="model"
      :class="right ? 'text-field-ref input-right' : 'text-field-ref'"
      :label="label"
      :hint="hint"
      :persistent-hint="true"
      :suffix="suffixComputed"
      :error-messages="errors"
      :append-outer-icon="outerIcon"
      tabindex="-1"
      hide-details="auto"
      dense
      outlined
      readonly
      :clearable="clearable"
      @click:append-outer="onClickOuterIcon"
    ></v-text-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
export default {
  name: 'TextFieldRef',

  components: {
    ValidationProvider,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    hint: {
      type: String,
      required: false,
    },
    suffix: {
      type: String,
      required: false,
    },
    right: {
      type: Boolean,
      required: false,
      default: false,
    },
    validationMode: {
      type: String,
      required: false,
      default: 'aggressive',
    },
    rules: {
      type: String,
      required: false,
      default: null,
    },
    outerIcon: {
      type: String,
      required: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    model: {
      get() {
        if (typeof this.value == 'number') {
          return this.value
        } else {
          return this.value ? (this.value != '' ? this.value : ' ') : ' '
        }
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    suffixComputed() {
      return this.suffix
    },
    validationModeComputed() {
      return this.validationMode
    },
    labelComputed() {
      return this.label
    },
    rulesComputed() {
      if (this.rules) {
        return this.rules
      } else {
        return ''
      }
    },
  },

  methods: {
    onClickOuterIcon() {
      this.$emit('onClickOuterIcon')
    },
  },
}
</script>
<style>
/** ラベルの文字色指定 */
.text-field-ref div.v-text-field__slot label {
  color: rgba(0, 0, 0);
}
/** 入力値の文字色指定 */
.text-field-ref input {
  color: rgba(0, 0, 0);
  font-size: 100%;
}
/** ボーダー色指定 */
.text-field-ref > .v-input__control > .v-input__slot > fieldset {
  border-style: solid;
  border-width: 1px;
  border-color: #bdbdbd;
}
</style>
